import React from 'react';

import { useBreakpoint } from '~/techstyle-shared/react-components';

import DesktopGridView from './DesktopGridView';
import MobileGridView from './MobileGridView';

const GridViewRenderer = () => {
  const { isMobile } = useBreakpoint();

  return isMobile ? <MobileGridView /> : <DesktopGridView />;
};

export default GridViewRenderer;
